module.exports = __webpack_public_path__ + "static/media/shovel.72db284c.svg";